import axios from 'axios';

export const INTEGRACION_PANTALLAS_MAXWELL_CARGA_INICIAL = "INTEGRACION_PANTALLAS_MAXWELL_CARGA_INICIAL";
export const INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL = "INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL";

let _dispatch = null;


export function cargaInicialPantalla(login) {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        const urlSitio = new URL(tokenApiUrl).origin + "/";

        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}`;

        let params = {
            "UID": login,
            "SID": 0,
            "TStamp": formattedDate
        }

        let urlEndpoint = tokenApiUrl + "/ObjectToHash";

        axios.post(urlEndpoint, params, {
            headers: {
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Origin": "*",
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json',
            }
        }
        )
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                mostrarMensajeError("serverError", "ObjectToHash");
            } else if (error.request) {
                console.log(error.request);

                mostrarMensajeError("noResponse", "ObjectToHash");
            } else {
                console.log('Error', error.message);

                mostrarMensajeError("requestConfig", "ObjectToHash");
            }

            console.log(error.config);
            console.log(error.toJSON());
        })
        .then(res => {
            _dispatch({ type: INTEGRACION_PANTALLAS_MAXWELL_CARGA_INICIAL, urlSitio: urlSitio, token: res.data.token });
        })
    }
}


export function mostrarOcultarModal(valor) {
    return (dispatch, getState) => {
        _dispatch({ type: INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL, mostrarModal: valor, mensaje: "" });
    }
}


function mostrarMensajeError(tipoError, endpoint) {
    let mensaje = "";

    switch (tipoError) {
        case "requestConfig": {
            mensaje = "Ocurrió un error de configuración de la request. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
        case "serverError": {
            mensaje = "Ocurrió un error de comunicación con el servidor. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
        case "noResponse": {
            mensaje = "No se obtuvo respuesta del lado del servidor. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
    };

    _dispatch({ type: INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL, mostrarModal: true, mensaje });
}
